import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PilotTransferPoint, PortOfCall} from "@portbase/bezoekschip-service-typescriptmodels";
import {PortvisitUtils} from "../portvisit-utils";
import {removeItem, replaceOrAddItem, sendQuery, uuid} from "../../common/utils";
import {Handler} from "../../common/handlers/handler";
import {View} from "../../common/handlers/view";
import {HandleQuery} from "../../common/handlers/handle-query";
import {Observable, ReplaySubject, Subject} from "rxjs";
import {HandleCommand} from "../../common/handlers/handle-command";
import {AppContext} from "../../app-context";

@Component({
    selector: 'app-edit-port-of-call',
    templateUrl: './edit-port-of-call.component.html',
    styleUrls: ['./edit-port-of-call.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Handler()
export class EditPortOfCallComponent extends View implements OnInit {
  context = AppContext;
  portOfCall: PortOfCall;
  refData = PortvisitUtils;
  pilotTransferPoints: Subject<PilotTransferPoint[]>
  customsOffices = sendQuery('com.portbase.bezoekschip.common.api.visit.GetCustomsOffices', {countryCode: 'NL'});

  negativeLogicFormatter = value => value ? "Disabled" : "Enabled";
  positiveLogicFormatter = value => value ? "Enabled" : "Disabled";
  reportingFormatter = value => value ? "Reported" : "Not reported";
  requirementFormatter = value => value ? "Required" : "Not required";

  @Input("portOfCall")
  set setPortOfCall(portOfCall: PortOfCall) {
    this.portOfCall = portOfCall;
    if (portOfCall.orderNauticalServicesEnabled) {
      this.initialiseDeadlines();
    }
  }

  ngOnInit() {
    this.pilotTransferPoints = new ReplaySubject(1);
    this.pilotTransferPoints.next(this.portOfCall.pilotTransferPoints);
  }

  protected orderNauticalServicesChanged(enabled: boolean) {
    if (enabled) {
      this.initialiseDeadlines();
    }
  }

  private initialiseDeadlines() {
    this.portOfCall.orderDeadlines = this.portOfCall.orderDeadlines || {};
    this.portOfCall.orderDeadlines.incomingAtSea = this.portOfCall.orderDeadlines.incomingAtSea || {};
    this.portOfCall.orderDeadlines.incomingAtHinterland = this.portOfCall.orderDeadlines.incomingAtHinterland || {};
    this.portOfCall.orderDeadlines.betweenBerths = this.portOfCall.orderDeadlines.betweenBerths || {};
  }

  protected addNewPilotTransferPoint(): void {
    this.updatePilotTransferPoint({
      pilotTransferPointId: uuid(),
      name: "New pilot transfer point",
      nextTransferPoints: []
    });
  }

  @HandleQuery("getAllPilotTransferPoints")
  getAllPilotTransferPoints(): Observable<PilotTransferPoint[]> {
    return this.pilotTransferPoints.asObservable();
  }

  @HandleCommand("updatePilotTransferPoint")
  updatePilotTransferPoint(pilotTransferPoint: PilotTransferPoint): void {
    this.portOfCall.pilotTransferPoints = replaceOrAddItem(this.portOfCall.pilotTransferPoints, pilotTransferPoint, p => p.pilotTransferPointId === pilotTransferPoint.pilotTransferPointId);
    this.pilotTransferPoints.next(this.portOfCall.pilotTransferPoints);
  }

  deletePilotTransferPoint(pilotTransferPoint: PilotTransferPoint) {
    return () => {
      removeItem(this.portOfCall.pilotTransferPoints, pilotTransferPoint);
      this.pilotTransferPoints.next(this.portOfCall.pilotTransferPoints);
    }
  }

  nextTransferPointsFormatted = (nextTransferPoints: string[]): string =>
    (this.portOfCall.pilotTransferPoints || []).filter(p => (nextTransferPoints || []).includes(p.pilotTransferPointId))
      .map(p => p.name).join(", ");
}
